import { render, staticRenderFns } from "./mapTiffTest.vue?vue&type=template&id=a38f1e10&scoped=true"
import script from "./mapTiffTest.vue?vue&type=script&lang=js"
export * from "./mapTiffTest.vue?vue&type=script&lang=js"
import style0 from "./mapTiffTest.vue?vue&type=style&index=0&id=a38f1e10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a38f1e10",
  null
  
)

export default component.exports